/* eslint-disable indent */
import { useRouter } from 'next/router';

import { Box, Button, Grid, Typography, useTheme } from '@mui/material';
import { useTranslation } from 'next-i18next';

import { Container, SubTitle, Title } from './style';

import Image from '@components/atoms/image';
import { getNamespaces } from '@helpers/i18nUtils';
import { useBreakpointV3, useDegreeLandingPageData } from '@helpers/use';

export const DegreeStructSection = () => {
  const { isMobile } = useBreakpointV3();
  const theme = useTheme();
  const router = useRouter();
  const degreeIdName = (router.query.degreeIdName as string) || '';
  const { t } = useTranslation(getNamespaces({ namespaces: [degreeIdName] }));

  const universityId = router.query.universityIdName as string;

  const { landingPage } = useDegreeLandingPageData(universityId, degreeIdName);

  return (
    <Box mb={10}>
      <Box
        display="flex"
        flexDirection={{
          xs: 'column-reverse',
          md: 'column',
        }}
      >
        <Container mb={{ md: 10 }}>
          <Title>{t('degree_landing_page.degree_struct.path_to_master_degree.title')}</Title>
          {isMobile
            ? landingPage?.pathToMasterDegreeMobileImageUrl && (
                <Image src={landingPage.pathToMasterDegreeMobileImageUrl} alt="Path to master degree" />
              )
            : landingPage?.pathToMasterDegreeImageUrl && (
                <Image src={landingPage.pathToMasterDegreeImageUrl} alt="Path to master degree" />
              )}
        </Container>

        <Box mb={{ xs: 15, md: 0 }} sx={{ py: { md: 8, xs: 5 } }} bgcolor="#f5f6f7">
          <Box mb={5} px={3}>
            <Title disableSpacing>{t('degree_landing_page.degree_struct.title')}</Title>
            <SubTitle>
              {landingPage?.degreeName} {landingPage?.majorName}
            </SubTitle>
          </Box>
          <Container>
            <Grid
              container
              flexDirection={{
                md: 'row-reverse',
              }}
              spacing={{
                xs: 3,
                md: 6,
              }}
            >
              {landingPage?.degreeStructureImageUrl && (
                <Grid item md={6} xs={12} alignSelf="start">
                  <Image src={landingPage.degreeStructureImageUrl} alt="Degree structure" />
                </Grid>
              )}
              <Grid item md xs={12}>
                <Box sx={{ display: 'flex', flexDirection: 'column', gap: '24px' }}>
                  <Box sx={{ display: 'flex', flexDirection: 'column', gap: '16px' }}>
                    <Typography variant="h3v2" color={theme.palette.textV2.primary}>
                      {t('degree_landing_page.degree_plan_struct.title')}
                    </Typography>
                    {landingPage?.plans.map((plan) => (
                      <Box key={plan.title} sx={{ display: 'flex', flexDirection: 'column', gap: '4px' }}>
                        <Typography variant="h4" color={theme.palette.textV2.primary}>
                          {plan.title ?? ''}
                        </Typography>
                        <Typography
                          variant="body1lanna"
                          color={theme.palette.textV2.secondary}
                          sx={{ whiteSpace: 'pre-line' }}
                        >
                          {plan.description ?? ''}
                        </Typography>
                      </Box>
                    ))}
                  </Box>
                  {landingPage?.degreeStructureFileUrl && (
                    <Button
                      variant="outlined"
                      sx={{ maxWidth: { xs: 'unset', md: '287px' }, textTransform: 'none' }}
                      href={landingPage?.degreeStructureFileUrl}
                      target="_blank"
                      fullWidth={isMobile}
                    >
                      {t('degree_landing_page.degree_plan_struct.button')}
                    </Button>
                  )}
                </Box>
              </Grid>
            </Grid>
          </Container>
        </Box>
      </Box>
    </Box>
  );
};
